import { render, staticRenderFns } from "./ElemToConst.vue?vue&type=template&id=0fedabcf&scoped=true&"
import script from "./ElemToConst.vue?vue&type=script&lang=ts&"
export * from "./ElemToConst.vue?vue&type=script&lang=ts&"
import style0 from "./ElemToConst.vue?vue&type=style&index=0&id=0fedabcf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedabcf",
  null
  
)

export default component.exports